interface ICoordinates {
    lat?: number;
    lng?: number;
}

export const NewCoordinates: ICoordinates = {};

export default ICoordinates;
